import { MutationTree } from "vuex";
import { WebhooksState, Webhook, WebhookItem, WebhookAttempt } from "../types";

const mutations: MutationTree<WebhooksState> = {
  setCurrentWebhook(state, webhookItem: WebhookItem) {
    state.currentWebhook = webhookItem;
  },
  setWebhooks(state, webhookList: Webhook) {
    state.webhooks = webhookList;
  },
  setCurrentWebhookAttempts(state, webhookAttemptList: WebhookAttempt) {
    state.currentWebhookAttempts = webhookAttemptList;
  },
  setIsViewing(state, isViewing: string) {
    state.viewing = isViewing;
  },
  setTotalAttempts(state, totalAttempts: number) {
    state.totalAttempts = totalAttempts;
  },
  setTotalSucceededAttempts(state, totalSucceededAttempts: number) {
    state.totalSucceededAttempts = totalSucceededAttempts;
  },
  setTotalFailedAttempts(state, totalFailedAttempts: number) {
    state.totalFailedAttempts = totalFailedAttempts;
  },
};

export default mutations;
